import Common from '../../Common';
import Queue from './wallboard/Queue';
import Token from './wallboard/Token';

interface Options {
	limit?: number,
	limit_from?: number,
	orderBy?: string,
	orderDir?: string,
}

export interface Template {
	id: id
	pbx_company_id: id
	theme: string
	theme_color: string
	name: string
	updated: string
	column_amount: string
	queues_per_page: string
	timeout: string
	common: "0" | "1"
	unpin: "0" | "1"
	expanded: "0" | "1"
}

const Wallboard = class extends Common {
	token: InstanceType<typeof Token>;
	queue: InstanceType<typeof Queue>;

	constructor(headers: ApiHeaders) {
		super(headers)

		this.token = new Token(headers);
		this.queue = new Queue(headers);
	}

	read(userId: id, id: id, token?: string) {
		const gets: {[key: string]: typeof token} = {};

		if(token) {
			gets['token'] = token;
		}

		return this.get(`/user/${userId}/wallboard/${id}`, gets)
	}

	browse = (userId: id, options?: Options): CustomResponseBrowse<{ templates: Template[] }> =>
		this.get(`/user/${userId}/wallboard`, options)
}

export default Wallboard
